import { proxy } from 'valtio';

export const DEFAULT_GEOREFERENCED_MAP_OPACITY = 0.8;
/** Pages the Geo-referenced Maps panel lists per map before, and with each, "Show more". */
export const GEOREFERENCED_MAP_PAGES_STEP = 50;

/** Opacity shared by every visible geo-referenced map, and how many pages the panel lists per map. Visibility itself lives in `layerStore.visibleLayerIds`. */
const georeferencedMapsStore = proxy({
  opacity: DEFAULT_GEOREFERENCED_MAP_OPACITY,
  /** Pages listed per map, keyed by the map's panel section id; a map not in here lists `GEOREFERENCED_MAP_PAGES_STEP`. */
  shownPageCounts: {} as Record<string, number>,
  setOpacity(opacity: number) {
    georeferencedMapsStore.opacity = Math.min(1, Math.max(0, opacity));
  },
  showMorePages(fileSectionId: string) {
    const shown = georeferencedMapsStore.shownPageCounts[fileSectionId] ?? GEOREFERENCED_MAP_PAGES_STEP;
    georeferencedMapsStore.shownPageCounts[fileSectionId] = shown + GEOREFERENCED_MAP_PAGES_STEP;
  },
});

export default georeferencedMapsStore;
